<template>
  <div class="YuanAIBox">
    <div class="titleBox">
      <img class="allImage" :src="firstPhoto" alt="" />
      <div class="ImgOrText">
        <img :src="textYuanAI" alt="" />
        <p class='title_p'>
          在实体展馆打造领域具备卓越的一站式服务能力，从前期策划入手，深度挖掘客户意图与展示核心，运用创意思维规划展馆布局与参观流线使空间布局合理
          且主题鲜明。设计阶段，融合美学理念与功能需求，无论是现代简约风格、古典奢华风格还是科技未来风格，都能精准把控施工时，专业施工团队遵循严格
          工程管理规范，严选优质建材，保障展馆架构坚实、工艺精细。在软硬件安装层面，不仅擅长筛选适配的多媒体展示软件及智能交互系统，还能自主开发定
          制化软件，以专业技术确保精准安装调试，达成软硬件完美协同。无论是文化艺术、科技展览或是企业展示场馆，皆能塑造出别具一格、令人难忘的实体展
          馆项目
        </p>
      </div>
    </div>
    <div class="pintu">
      <img class="zhu1" :src="zhu1" alt="" />
      <img class="huawen" :src="huawen" alt="" />
      <img class="zhu2" :src="zhu2" alt="" />
      <img class="txgwz" :src="txgwz" alt="" />
    </div>
    <div class="zhanshi">
      <img :src="txg1" alt="" />
    </div>
    <div
      class="zhanshi pt"
      style="
        background: linear-gradient(
          to top,
          #413a34 0%,
          #3f3932 41%,
          #3e3832 49%,
          #33302b 97%
        );
      "
    >
      <img :src="txg2" alt="" />
    </div>
    <div class="line">
      <img :src="fgx" alt="" />
    </div>
    <div class="ul" style="background: #3f3a34">
      <div v-for="(v, k) in imgitems" :key="k">
        <img :src="v.url" alt="" />
      </div>
    </div>
    <div class="line">
      <img :src="fgx" alt="" />
    </div>
    <div class="midBox">
      <div class="setAllBox" v-for="(v, k) in footerList" :key="k">
        <div class="por pb">
          <img
            class="allImage"
            style="height: 100%; overflow: hidden"
            :src="v.src"
            alt=""
          />
        </div>
        <div class="por" style="margin-right: 0px">
          <img
            class="allImage"
            style="height: 100%; overflow: hidden"
            :src="v.otherSrc"
            alt=""
          />
        </div>
      </div>
    </div>
     <div class="footer1">
      <img :src="hf" alt="" />
    </div>
    <div class="footer2">
      <img :src="zx" alt="" />
    </div>
    <div class="footer1">
      <img :src="ls" alt="" />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import firstPhoto from "@/assets/XXZT/top.webp";
import textYuanAI from "@/assets/XXZT/xxzg.webp";
import huawen from "@/assets/XXZT/huawen.webp";
import zhu1 from "@/assets/XXZT/zhu1.webp";
import zhu2 from "@/assets/XXZT/zhu2.webp";
import txg1 from "@/assets/XXZT/txg1.webp";
import txg2 from "@/assets/XXZT/txg2.webp";
import txgwz from "@/assets/XXZT/txgwz.webp";
import fgx from "@/assets/XXZT/fgx.webp";
import imgitems1 from "@/assets/XXZT/by.webp";
import imgitems2 from "@/assets/XXZT/gr.webp";
import imgitems3 from "@/assets/XXZT/sp.webp";
import imgitems4 from "@/assets/XXZT/qs.webp";
import XSZG from "@/assets/XXZT/cj1.webp";
import STZG from "@/assets/XXZT/cj2.webp";
import VR from "@/assets/XXZT/cj3.webp";
import VisionPro from "@/assets/XXZT/cj4.webp";
import hf from "@/assets/XXZT/hf.webp";
import zx from "@/assets/XXZT/zx.webp";
import ls from "@/assets/XXZT/ls.webp";
const footerList = ref([
  {
    src: XSZG,
    otherSrc: STZG,
  },
  {
    src: VR,
    otherSrc: VisionPro,
  },
]);
const imgitems = ref([
  {
    url: imgitems1,
  },
  {
    url: imgitems2,
  },
  {
    url: imgitems3,
  },
  {
    url: imgitems4,
  },
]);
</script>

<style scoped lang="scss">
@import "./index.scss";
</style>
